module.exports = __webpack_public_path__ + "media/captain_lee.ab22a08a.mp3";